import { type ReactElement } from 'react';
import { cn } from '@/lib/cn';
import type { Arrangement } from '@/lib/types';

type Props = {
  arrangement: Arrangement;
  selected: boolean;
  onSelect: () => void;
};

function handleKeyActivation(event: React.KeyboardEvent, onSelect: () => void): void {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    onSelect();
  }
}

export function SettingPickerCard({ arrangement, selected, onSelect }: Props): ReactElement {
  const { prettyName, keyName, arrangerName } = arrangement;

  return (
    <div
      role="radio"
      aria-checked={selected}
      tabIndex={0}
      onClick={onSelect}
      onKeyDown={(e) => handleKeyActivation(e, onSelect)}
      className={cn(
        'flex flex-col gap-1 rounded-[var(--r-sm)] border p-4 cursor-pointer transition-all',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand)]',
        'focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--bg-surface)]',
        selected
          ? 'border-[var(--brand)] bg-[var(--brand)]/5 text-[var(--ink)]'
          : 'border-[var(--rule)] bg-[var(--bg-surface)] text-[var(--ink)] hover:border-[var(--brand)]',
      )}
    >
      <span className="text-sm font-semibold">{prettyName}</span>
      {keyName != null && (
        <span className="text-xs text-[var(--ink-2)]">{keyName}</span>
      )}
      {arrangerName != null && (
        <span className="text-xs text-[var(--ink-3)]">{arrangerName}</span>
      )}
    </div>
  );
}
